<iframe [src]="getVideo(media.url)" *ngIf="ready" class="vimeo-player" allow="fullscreen" allowFullScreen></iframe>

<div class="vimeo-not-ready" *ngIf="!ready">
    <div class="">{{ 'words.video-process' | translate }}</div>
</div>
